import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reportActions } from '../../store/reportStore';
import { withLocalize } from 'react-localize-redux';
import ExcelExportButton from '../common/excelExportButton';
import OldStyleSubsection from '../common/oldStyleSubsection';

class RelationsCRSRData extends React.Component {
    shouldComponentUpdate(nextProps, _) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    render() {

        const { data } = this.props.sections.find(o => o.id === this.props.sectionId);
        return (data === undefined || data === null ? null : this.renderContent());
    }

    renderContent = () => {
        var subsections = this.props.sections.find(s => s.id === this.props.sectionId).subsections;

        return (
            <div>
                {subsections.map(s => <OldStyleSubsection isBold
                    key={s.id}
                    sectionId={this.props.sectionId}
                    subsectionId={s.id}
                    subsectionName={s.Name}
                    subsectionData={{ type: s.params.type }}
                />)}

                <ExcelExportButton link="relations-crsr" entityId={this.props.id} report={this.props.reportType} />
            </div>
        )
    }
}

export default withLocalize(connect(
    state => ({ ...state.report }),
    dispatch => bindActionCreators(reportActions, dispatch)
)(RelationsCRSRData));